import {Component, HostListener, Inject, OnInit} from '@angular/core';

import {MenuService, SubtitlesService, ViewsService} from "../core";
import {StylesService} from "../core/style.service";
import {DOCUMENT} from "@angular/common";


@Component({
    selector: 'app-app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    constructor(
        @Inject(DOCUMENT) private document: Document,
        private menu: MenuService,
        private style: StylesService,
        private subtitles: SubtitlesService,
        public views: ViewsService,
    ) {
    }

    ngOnInit() {
        const savedTag = window.localStorage.getItem('languageTag');
        this.subtitles.getSubtitles('default', savedTag ?? '');
        this.style.setDefaultStyle();

        if (!(/iPad|iPhone|iPod/.test(navigator.userAgent) /* && !window.MSStream */) || window.innerWidth > 696) {
            this.document.body.className += ' hasHover';
        }
    }

    clickOutside($event: Event): void {
        const target = $event.target as Element;
        if ((target.parentElement !== null && target.parentElement.className !== 'top-menu__dropdown-button')
            && target.parentElement.className !== 'top-menu__inner') {
            this.menu.showDropdownMenu = false;
            $event.stopPropagation();
        }
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: Event) {
        this.views.setSubMenuWindowValues();
        this.views.setManufacturerMaxHeight();
        this.views.setAlarmHistoryHeights();
    }
}
